import { createContext } from 'react';

export interface SnackbarContextType {
  triggerSnackbar: () => void;
  // eslint-disable-next-line no-unused-vars
  setAlert: (_: JSX.Element) => void;
}

const SnackbarContext = createContext<SnackbarContextType>({
  triggerSnackbar: () => {
    /* intentionally left blank */
  },
  setAlert: () => {
    /* intentionally left blank */
  },
});

export default SnackbarContext;
